// LeftStepperContext.tsx
import React, { createContext, useContext, useState } from "react";

type LeftStepperContextType = {
  leftStepperHide: boolean;
  toggleLeftStepper: () => void;
  handleLeftStepperHide: (hide: boolean) => void;
};

const LeftStepperContext = createContext<LeftStepperContextType | undefined>(undefined);

export const LeftStepperProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [leftStepperHide, setLeftStepperHide] = useState(false);

  const toggleLeftStepper = () => {
    setLeftStepperHide((prev) => !prev);
  };
  const handleLeftStepperHide = (hide: boolean) => {
    setLeftStepperHide(hide);
  };

  return (
    <LeftStepperContext.Provider value={{ leftStepperHide, toggleLeftStepper, handleLeftStepperHide }}>
      {children}
    </LeftStepperContext.Provider>
  );
};

export function useLeftStepper(): LeftStepperContextType {
  const context = useContext(LeftStepperContext);
  if (!context) {
    throw new Error("useLeftStepper must be used within a LeftStepperProvider");
  }
  return context;
}